import { Icon, IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { OutlinedInput } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchBarProps as Props } from './types';

export const SearchBar = memo(({ className, onSearch }: Props) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    setInputValue(value);
    if (onSearch) onSearch(value);
  };

  return (
    <Styled.Wrapper
      className={classnames('SearchBar', className)}
      sx={SX.root}
      direction="row"
      alignItems="center"
      gap={1}
    >
      <OutlinedInput
        placeholder="Eg, Robert, Robert Gates, Gates"
        onChange={handleInputChange}
        value={inputValue}
        startAdornment={<Icon name="search" size={16} color="grey.500" />}
        size="small"
        fullWidth
      />
      <IconButton
        icon="filter-alt-outline"
        size="small"
        variant="outlined"
        iconSize={20}
        disabled
      />
    </Styled.Wrapper>
  );
});

SearchBar.displayName = 'SearchBar';
